wbApp.controller('StudentsActionsCtrl', ['$scope', 'courseRegistrationSvc', 'tenantSettingSvc',
function ($scope, courseRegistrationSvc, tenantSettingSvc) {

    $scope.tenantSettings = tenantSettingSvc.settings;

    var selectedStudent = null;
    var isActive = false;
    var loaded = false;
    $scope.actions = [];

    $scope.$on('studentSelectionChanged', function (e, data) {
        if (data.student) {
            if (isActive) {
                if (selectedStudent !== data.student || data.refresh) {
                    $scope.actions = courseRegistrationSvc.getAllActionsByStudent(data.student.id);
                }
                loaded = true;
            } else {
                loaded = false;
            }
        } else {
            $scope.actions.length = 0;
        }
        selectedStudent = data.student;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 2) {
            if (!isActive) {
                isActive = true;
                if (!loaded && selectedStudent) {
                    $scope.actions = courseRegistrationSvc.getAllActionsByStudent(selectedStudent.id);
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.gridOptions = {
        sortInfo: { fields: ['semesterName'], directions: ['asc'] },
        columnDefs: [
            { field: 'semesterName', displayName: "TXT_LBL_SEMESTER", width: '140px' },
            { field: 'courseFullName', displayName: "TXT_LBL_ACTIONS", width: '300px' },
            { field: 'firstDate', displayName: "TXT_MENU_SCHEDULE", cellFilter: 'date:dd.MM.yy EEE HH:mm', width: '120px' },
            { field: 'notes', displayName: "TXT_LBL_NOTE" },
            { field: 'price', displayName: "TXT_LBL_PRICE", cellFilter: 'wbCurrencyFlt', width: '100px', align: 'right', smHide: true, mdHide: true },
            { field: 'paymentsSum', displayName: "TXT_LBL_PAYMENTS", cellFilter: 'wbCurrencyFlt', align: 'right', width: '100px', smHide: true },
            { field: 'registrationDate', displayName: "TXT_LBL_REGISTRATION_DATE", cellFilter: 'date:shortDate', width: '75px', smHide: true }
        ],
        noCommandColumn: true
    };

    if ($scope.tenantSettings.showArrearInsteadOfPayments) {
        $scope.gridOptions.columnDefs[4].field = 'arrear';
        $scope.gridOptions.columnDefs[4].displayName = 'TXT_LBL_ARREAR';
    }

}]);


